import { Delete, SvgIconComponent } from '@mui/icons-material';
import { IconButton, List, ListItem, ListItemText } from '@mui/material';
import { FC } from 'react';
import { AppIcons } from '../../settings/icons';

interface IProps 
{
  items: IItem[];
  hideIfEmpty?: boolean;
  onChangeRequest?: (index: number)=>void;
  onDeleteRequest?: (index: number)=>void;
}

export interface IItem
{
    title: string;
    icon?: SvgIconComponent;
}

const ItemList: FC<IProps> = ({ items, hideIfEmpty, onChangeRequest, onDeleteRequest }) => 
{
    return hideIfEmpty && items.length <= 0 ? (<></>) :
        (<List dense={true}>
            {items.map((item: IItem, index: number) => {
                const Icon = item.icon ?? AppIcons.DefaultListItem;
                return (
                    <ListItem
                        key={`item-list-${item.title}-${index}`}
                        secondaryAction={
                            onDeleteRequest ? (
                                <IconButton edge="end" aria-label="delete" onClick={(evt)=>{
                                    onDeleteRequest(index);
                                }}>
                                    <Delete />
                                </IconButton>
                            ) : undefined
                        }
                    >
                        <Icon sx={{marginRight: "5px"}}/>
                        <ListItemText
                            key={`item-list-text-${item.title}-${index}`}
                            primary={item.title}
                        />
                    </ListItem>
                )
            })}
        </List>);
};

export default ItemList;